import React from 'react';
import { congestionColor } from '../lib/driveBucket';

export default function CongestionBadge({ seconds, driveTimeSeconds }) {
  if (seconds == null) return <span className="text-gray-400">—</span>;
  const minutes = Math.round(Number(seconds) / 60);
  const color = congestionColor(seconds, driveTimeSeconds);
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium"
      style={{ backgroundColor: `${color}22`, color }}
    >
      {minutes} min
    </span>
  );
}
